import React, { Suspense } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { Protected } from './components/protected'
import { useDispatch, useSelector } from 'react-redux'
import './scss/style.scss'
import { hasSessionHint } from './services/authTokens'
import useMountEffect from './hooks/useMountEffect'
import { confirmAdminSession, setAnonymousAdminSession } from './services/adminSession'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Register = React.lazy(() => import('./views/pages/register/Register'))
const Reset = React.lazy(() => import('./views/pages/reset/forgotpass'))
const PassReset = React.lazy(() => import('./views/pages/reset/passreset'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))

const App = () => {
  const AuthReducer = useSelector((state) => state.AuthReducer)
  const dispatch = useDispatch()

  useMountEffect(() => {
    if (hasSessionHint()) {
      void confirmAdminSession({ dispatch })
      return
    }

    setAnonymousAdminSession(dispatch)
  })

  useMountEffect(() => {
    const onLogout = () => {
      setAnonymousAdminSession(dispatch)
    }
    window.addEventListener('onebody:auth:logout', onLogout)
    return () => window.removeEventListener('onebody:auth:logout', onLogout)
  })

  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Suspense fallback={loading}>
        <Routes>
          <Route exact path="/login" name="Login Page" element={<Login />} />
          <Route exact path="/register" name="Register Page" element={<Register />} />
          <Route exact path="/reset" name="Reset Password" element={<Reset />} />
          <Route exact path="/reset-password" name="Reset Password Link" element={<PassReset />} />
          <Route exact path="/404" name="Page 404" element={<Page404 />} />
          <Route exact path="/500" name="Page 500" element={<Page500 />} />
          <Route
            path="*"
            name="Home"
            element={
              <Protected authStatus={AuthReducer.authStatus} user={AuthReducer.data}>
                <DefaultLayout />
              </Protected>
            }
          />
        </Routes>
      </Suspense>
    </BrowserRouter>
  )
}

export default App
